












































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue, { PropType } from 'vue';

const ILLUSTRATION = ['setup', 'no-data', 'no-task', 'text-only'] as const;
const SIZE = ['small', 'large'] as const;

type Illustration = typeof ILLUSTRATION[number];
type Size = typeof SIZE[number];

export default Vue.extend({
  name: 'SldsIllustration',
  props: {
    type: {
      type: String as PropType<Illustration>,
      required: true,
      validator: (val) => ILLUSTRATION.includes(val),
    },
    size: {
      type: String as PropType<Size>,
      default: 'small' as Size,
      required: false,
      validator: (val) => SIZE.includes(val),
    },
    svgAttrs: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    classes(): string[] {
      return ['slds-illustration', `slds-illustration_${this.size}`];
    },
  },
});
